/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import bannerImg from "../../Assets/images/banner.jpg";
import { BiSearchAlt2 } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import keywordimage from "../../Assets/images/keyword.png";
import companyimage from "../../Assets/images/globe.png";
import servicesimage from "../../Assets/images/maintenance.png";
import locationimage from "../../Assets/images/location-pin.png";
import { api_url } from "../../Constants/web_services";
const HomeBanner = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [service, setService] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef();

  const options = {};

  useEffect(() => {
    const autoComplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      options
    );

    autoComplete.addListener("place_changed", () => {
      const selectedPlace = autoComplete.getPlace();
      if (selectedPlace && selectedPlace.address_components) {
        const countryComponent = selectedPlace.address_components.find(
          (component) => component.types.includes("country")
        );
        if (countryComponent) {
          const selectedCountry = countryComponent.long_name;
          setCountry(selectedCountry);
          inputRef.current.value = selectedCountry; // Manually set the input field value
        }
      }
    });
  }, [options]);

  const search = () => {
    if (keyword.length >= 2) {
      fetchSuggestions(keyword)
        .then(suggestions => {
          const keywordFound = suggestions.some(suggestion =>
            suggestion.title.toLowerCase() === keyword.toLowerCase()
          );

          if (!keywordFound) {
            addKeywordToDatabase(keyword).then(() => {
              performSearch();
            });
          } else {
            performSearch();
          }
        })
        .catch(error => {
          console.error("Error during search:", error);
        });
    } else {
      performSearch();
    }
  };

  const performSearch = () => {
    const queryParams = { keyword, company, country, service };
    navigate("/search?" + encodeQueryParams(queryParams));
  };

  const encodeQueryParams = (params) => {
    const encodedParams = [];
    for (const key in params) {
      if (Object.hasOwnProperty.call(params, key)) {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(params[key]);
        encodedParams.push(`${encodedKey}=${encodedValue}`);
      }
    }
    return encodedParams.join("&");
  };

  const handleInputChange = (e) => {
    const keywordValue = e.target.value;
    setKeyword(keywordValue);
    if (keywordValue.length >= 2) {
      fetchSuggestions(keywordValue).then(setSuggestions);
    } else {
      setSuggestions([]);
    }
  };

  const fetchSuggestions = (keywordValue) => {
    return fetch(api_url + `/api/suggestions?keywordValue=${keywordValue}`)
      .then((response) => response.json())
      .then((data) => data.data.slice(0, 10))
      .catch((error) => {
        console.error("Error fetching suggestions:", error);
        return [];
      });
  };

  const addKeywordToDatabase = (keywordValue) => {
    return fetch(api_url + `/api/addKeyword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ title: keywordValue })
    })
      .then(response => response.json())
      .then(data => {
        console.log("Keyword added:", data);
      })
      .catch(error => {
        console.error("Error adding keyword:", error);
      });
  };

  const handleSuggestionClick = (suggestion) => {
    setKeyword(suggestion.title);
    setSuggestions([]);
  };

  return (
    <section className="aon-banner-wrap">
      <div className="aon-banner-outer sf-overlay-wrapper">
        <div className="aon-banner-pic">
          <div className="aon-curve-area" />
          <div
            className="aon-overlay-main"
            style={{ opacity: "0.85", backgroundColor: "#022278" }}
          />
          <img src={bannerImg} width={"500px"} alt="" />
        </div>
        <div className="aon-banner-text">
          <div className="container">
            <div className="aon-bnr-write">
              <h2 className="text-top-line">
                Meet<span className="text-secondry"> Experts</span> &amp;{" "}
              </h2>
              <h2 className="text-bot-line">Navigate Software Galaxy</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="aon-find-bar aon-findBar-vertical">
        <div className="container">
          <div className="search-form ">
            <form className="clearfix search-providers" method="get">
              <input type="hidden" name="s" />
              <div className="aon-searchbar-table">
                <div className="aon-searchbar-left">
                  <ul className="clearfix sf-searchfileds-count-5 ps-0">
                    <li>
                      <label>Keyword</label>
                      <input
                        value={keyword}
                        onKeyUp={handleInputChange}
                        onChange={(e) => setKeyword(e.target.value)}
                        type="text"
                        placeholder="Enter Keyword"
                        id="keyword"
                        name="keyword"
                        className="form-control sf-form-control"
                      />
                      <div className="suggestions-container">
                        {suggestions.map((suggestion, index) => (
                          <div
                            key={index}
                            className="suggestion-item"
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            <h6 className="suggestion-title-form">
                              {suggestion.title}
                            </h6>
                          </div>
                        ))}
                      </div>
                      <span className="sf-search-icon">
                        <img src={keywordimage} alt="" />
                      </span>
                    </li>
                    <li>
                      <label>Services</label>
                      <input
                        type="text"
                        value={service}
                        onChange={(e) => setService(e.target.value)}
                        placeholder="Service"
                        id="service"
                        name="service"
                        className="form-control sf-form-control"
                      />
                      <span className="sf-search-icon">
                        <img src={servicesimage} alt="" />
                      </span>
                    </li>
                    <li>
                      <label>Company</label>
                      <input
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                        type="text"
                        placeholder="Company Name"
                        id="company"
                        name="company"
                        className="form-control sf-form-control"
                      />
                      <span className="sf-search-icon">
                        <img src={companyimage} alt="" />
                      </span>
                    </li>
                    <li>
                      <label>Location</label>
                      <input
                        ref={inputRef}
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        type="text"
                        placeholder="Search Location"
                        id="country"
                        name="country"
                        className="form-control sf-form-control"
                      />
                      <span className="sf-search-icon">
                        <img src={locationimage} alt="" />
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="aon-searchbar-right">
                  <button
                    type="button"
                    onClick={search}
                    className="text-decoration-none site-button"
                  >
                    <BiSearchAlt2 size={22} /> Find Provider
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
